export const DISPLAY_RATING_STARS = [1, 2, 3, 4, 5];
export const DISPLAY_REVIEW_STARS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
